export enum InvoiceStatus {
  Collection = 'Collection',
  Paid = 'Paid',
  UnderReview = 'Under Review',
  ProcessingPayment = 'Processing Payment',
}
